import { forwardRef } from 'react';

import './Layout.styles.css';

interface LayoutProps {
    level?: number,
    className?: string,
    style?: React.CSSProperties,
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void,
    children: React.ReactNode
}

const Layout = forwardRef<HTMLDivElement, LayoutProps>(({ level = 1, className = '', style, children, onClick }, ref) => {
    return <div className={`layout layout-level-${level} ${className}`} style={style} onClick={onClick} ref={ref}>{ children }</div>
});

export default Layout;
